class REGALO2GiftManager {
  constructor() {
    this.discountCode = 'REGALO2';
    this.giftProductId = '11605749301516';
    this.giftVariantId = null;
    this.init();
  }
  
  async init() {
    await this.getProductVariantId();
    this.waitForMonsterCart(() => {
      this.monitorApplyButton();
    });
  }
  
  async getProductVariantId() {
    try {
      const response = await fetch('/products/2-campioncini-omaggio-extra.js');
      const product = await response.json();
      this.giftVariantId = product.variants[0].id;
    } catch (error) {
      console.error('Error getting variant ID:', error);
    }
  }
  
  waitForMonsterCart(callback) {
    if (typeof monster_addToCart !== 'undefined') {
      callback();
    } else {
      setTimeout(() => this.waitForMonsterCart(callback), 100);
    }
  }
  
  monitorApplyButton() {
    document.addEventListener('click', (e) => {
      if (e.target.closest('#mu-coupon .mu-coupon-apply')) {
        const discountInput = document.querySelector('#mu-coupon input');
        if (discountInput && discountInput.value.toUpperCase() === this.discountCode) {
          // Start watching for error messages immediately
          this.watchForErrorMessage();
          // Add the gift
          setTimeout(() => this.addGift(), 1000);
        }
      }
    });
  }
  
  watchForErrorMessage() {
    const couponContainer = document.querySelector('#mu-coupon');
    if (!couponContainer) return;
    
    // IMPROVEMENT 1: Check for existing errors first
    this.hideExistingErrors();
    
    // IMPROVEMENT 2: Create observer but don't disconnect after first error
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { // Element node
            this.checkAndHideError(node);
          }
        });
        
        // IMPROVEMENT 3: Also watch for text content changes
        if (mutation.type === 'childList') {
          // Check if existing elements got new text content
          if (mutation.target.nodeType === 1) {
            this.checkAndHideError(mutation.target);
          }
        }
      });
    });
    
    // Start observing
    observer.observe(couponContainer, {
      childList: true,
      subtree: true,
      characterData: true  // IMPROVEMENT 4: Watch for text changes too
    });
    
    // IMPROVEMENT 5: Keep watching longer, don't disconnect early
    setTimeout(() => {
      observer.disconnect();
    }, 8000); // Increased from 5 to 8 seconds
  }
  
  // IMPROVEMENT 6: Separate function to check existing errors
  hideExistingErrors() {
    const couponContainer = document.querySelector('#mu-coupon');
    if (!couponContainer) return;
    
    // Check all existing elements in the coupon container
    const allElements = couponContainer.querySelectorAll('*');
    allElements.forEach(element => {
      this.checkAndHideError(element);
    });
  }
  
  // IMPROVEMENT 7: Better error detection logic
  checkAndHideError(element) {
    if (!element || !element.textContent) return;
    
    const text = element.textContent.trim();
    
    // Check for REGALO2 error (case insensitive) and error keywords
    const isREGALO2Error = text.toLowerCase().includes('regalo2') && 
                          (text.toLowerCase().includes('not valid') || 
                           text.toLowerCase().includes('invalid') ||
                           text.toLowerCase().includes('non valido'));
    
    // IMPROVEMENT 8: Only hide actual error messages (with red styling)
    const hasErrorStyling = element.classList.contains('mu-bg-red-200') ||
                           element.classList.contains('error') ||
                           (element.style.color && element.style.color.includes('red'));
    
    if (isREGALO2Error && (hasErrorStyling || text.startsWith('Discount code'))) {
      element.style.display = 'none';
      console.log('REGALO2 error hidden:', text.substring(0, 50));
    }
  }
  
  addGift() {
    if (!this.giftVariantId) {
      console.error('Gift variant ID not ready');
      return;
    }
    
    monster_addToCart({
      id: this.giftVariantId,
      quantity: 1,
      properties: { '_free_gift': this.discountCode }
    }, false, () => {
      console.log('Gift added successfully!');
    });
  }
}

// Initialize (prevent duplicates)
let giftManagerInstance = null;
function initializeGiftManager() {
  if (!giftManagerInstance) {
    giftManagerInstance = new REGALO2GiftManager();
  }
}

document.addEventListener('DOMContentLoaded', initializeGiftManager);
if (document.readyState !== 'loading') {
  initializeGiftManager();
}